import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {
  GenericEntitySearchData,
  GenericEntitySearch,
  LookupResponse,
} from './generic-entity-search-model';
import { UntypedFormGroup, UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ValidatorFnService } from '../../dynamic-forms/services/form-utility/validator-fn.service';
import { GenericEntitySearchService } from './generic-entity-search.service';
import { GenericLookupResult } from '../../lookup/generic-lookup/generic-lookup';
import { Country } from '../../utility/ref-constants';
import { StringUtility } from '../../utility/string-utility';

@Component({
  selector: 'app-generic-entity-search',
  templateUrl: './generic-entity-search.component.html',
  styleUrls: ['./generic-entity-search.component.scss'],
  imports: [MatDialogModule, ReactiveFormsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GenericEntitySearchComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<GenericEntitySearchComponent>>(MatDialogRef);
  private fb = inject(UntypedFormBuilder);
  private validatorFnService = inject(ValidatorFnService);
  private service = inject(GenericEntitySearchService);

  searchData: GenericEntitySearchData;
  genericEntitySearchForm: UntypedFormGroup;
  hasSearched: boolean;
  searchResults: LookupResponse = new LookupResponse();
  selectedRow: GenericLookupResult;
  countries = Country;
  entity: string;

  
 

  constructor() {
    const data = inject<GenericEntitySearchData>(MAT_DIALOG_DATA);

    this.searchData = data;
  }

  ngOnInit() {
    this.entity = StringUtility.addSpacesBeforeCapitals(this.searchData.searchType);

    this.genericEntitySearchForm = this.fb.group(
      {
        name: [''],
        fein: [''],
        addressLine1: [''],
        addressLine2: [''],
        city: [''],
        state: [''],
        postalCode: [''],
      },
      { validators: this.validatorFnService.atLeastOneFieldValidator },
    );

    this.hasSearched = false;
  }

  handleSearch(searchValues: GenericEntitySearch) {
    this.service
      .search(this.searchData.searchType, searchValues)
      .subscribe(this.processSearchResults);
  }

  handleReset() {
    this.genericEntitySearchForm.reset();
    this.searchResults = new LookupResponse();
    this.selectedRow = null;
    this.hasSearched = false;
  }

  handleEntitySelect(entity: any) {
    this.selectedRow = entity;
  }

  private processSearchResults = (response: LookupResponse) => {
    if (response.total === 1) {
      const entity = response.data[0];
      this.dialogRef.close(entity);
    } else {
      this.searchResults = response;
      this.hasSearched = true;
    }
  };
}
